import type { ReactNode } from 'react'
import { Button, Callout } from 'admination-react'
import { formatDatum } from '@/core/lib/dates'
import { useApp } from '@/core/state/appStore'
import { ModalHeader, type TabOverrides } from '@/core/components/modal/ModalHeader'
import type { UnterschriftDokument, Unterschriften } from '../../api/unterschrift'
import { useUnterschriftOeffnen } from './use-unterschrift-oeffnen'

const NAME: Record<UnterschriftDokument, string> = { foerderplan: 'Förderplan', erstbericht: 'Erstbericht' }

export const unterschreibenText = (dokument: UnterschriftDokument) => `${NAME[dokument]} unterschreiben lassen`

export type Gespeichert = 'laden' | 'fehler' | Unterschriften

function Rahmen({ tabs, actions, children }: { tabs?: TabOverrides; actions?: ReactNode; children: ReactNode }) {
  const { dispatch } = useApp()
  return (
    <>
      <ModalHeader tabs={tabs} onClose={() => dispatch({ type: 'CLOSE' })}>{actions}</ModalHeader>
      <main className="form">
        <div className="section">
          <div className="section-body">{children}</div>
        </div>
      </main>
    </>
  )
}

export function UnterschriftBox({
  dokument,
  coachingId,
  tabs,
  stand,
  abgegebenAm = null,
  marker,
}: {
  dokument: UnterschriftDokument
  coachingId: string | null
  tabs?: TabOverrides
  stand: Gespeichert
  abgegebenAm?: string | null
  marker?: ReactNode
}) {
  const oeffnen = useUnterschriftOeffnen(dokument)
  const name = NAME[dokument]
  if (stand === 'laden' || stand === 'fehler') {
    return (
      <Rahmen tabs={tabs}>
        <Callout tone={stand === 'fehler' ? 'error' : 'info'} role={stand === 'fehler' ? 'alert' : 'status'}>
          {stand === 'fehler' ? `Der ${name} konnte nicht geladen werden.` : `Der ${name} wird geladen …`}
        </Callout>
      </Rahmen>
    )
  }
  const unterschreiben = !(stand.teilnehmende && stand.coach)
  return (
    <Rahmen tabs={tabs} actions={<div className="pill">
      <Button primaryAction disabled={!coachingId} onClick={() => coachingId && oeffnen(coachingId, !unterschreiben)}>
        {unterschreiben ? unterschreibenText(dokument) : `${name} ansehen`}
      </Button>
    </div>}>
      {marker}
      <Callout tone={unterschreiben ? 'info' : 'success'} role="status">
        {unterschreiben
          ? stand.coach && abgegebenAm
            ? `Abgegeben am ${formatDatum(abgegebenAm)} ohne Unterschrift der teilnehmenden Person. Sie wird nachgeholt.`
            : `Der ${name} ist gespeichert und wartet auf die Unterschriften.`
          : <>Der {name} ist von beiden unterschrieben.</>}
      </Callout>
    </Rahmen>
  )
}
